import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { URLS } from "../../Services/Constant";
import { get, patch, post, put } from "../../Services/ApiHandler";
import { toast } from "react-toastify";
import { checkPermission } from "../redux/api/PermissionManager";

function SmsGateway() {
  const [gatewayData, setGatewayData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [checkedItems, setCheckedItems] = useState({
    whatsapp: false,
    smart: { status: false, position: 1 },
    sms: { status: false, position: 2 },
  });

  const label = [
    { id: "whatsapp", value: "WhatsApp (for Log in)", isDropDown: false },
    { id: "smart", value: "MSG91", isDropDown: true },
    { id: "sms", value: "Ninos", isDropDown: true },
  ];

  const fetchData = async () => {
    const url = `${URLS.MASTERURL}by-ids?ids=38,39,34`;
    try {
      const res = await get(url);
      console.log("response", res);

      const data = res?.data || [];
      setGatewayData(data);

      const whatsappItem = data.find((item) => item?.name === "Whatsapp");
      const smartItem = data.find((item) => item?.name === "MSG91");
      const smsItem = data.find((item) => item?.name === "Ninos");

      const smartPos = smartItem?.position ?? 1;
      const smsPos = smartPos === 1 ? 2 : 1;

      setCheckedItems({
        whatsapp: whatsappItem?.status ?? false,
        smart: { status: smartItem?.status ?? false, position: smartPos },
        sms: { status: smsItem?.status ?? false, position: smsPos },
      });
    } catch (err) {
      console.log("err", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handlerClick = (e, id) => {
    const value = e.target.checked;

    if (id === "whatsapp") {
      setCheckedItems((prev) => ({ ...prev, whatsapp: value }));
    } else {
      setCheckedItems((prev) => ({
        ...prev,
        [id]: { ...prev[id], status: value },
      }));
    }
  };

  const handleSmartPriorityChange = (e) => {
    const newSmartPos = Number(e.target.value);
    const newSmsPos = newSmartPos === 1 ? 2 : 1;

    setCheckedItems((prev) => ({
      ...prev,
      smart: { ...prev.smart, position: newSmartPos },
      sms: { ...prev.sms, position: newSmsPos },
    }));
  };

  const handleStatus = async (id, newStatus) => {
    setLoading(true);
    const formdata = new FormData();
    formdata.append("status", newStatus);
    try {
      const res = await post(`${URLS.MASTERURL}${id}/status/`, formdata);
      if (res?.status === "success") {
        toast.success(res?.message || "Status updated");
        fetchData();
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status");
    } finally {
      setLoading(false);
      setIsEdit(false);
    }
  };
  const handleSubmit = async () => {
    const whatsappItem = gatewayData.find((ele) => ele?.name === "Whatsapp");
    const smartItem = gatewayData.find((ele) => ele?.name === "MSG91");
    const smsItem = gatewayData.find((ele) => ele?.name === "Ninos");
 if (!checkedItems.smart.status && !checkedItems.sms.status) {
   toast.error("At least one SMS provider (MSG91 or Ninos) must be active.");
   return;
 }
    console.log(
      "Submit checkedItems:",
      whatsappItem?.status,
      checkedItems.whatsapp,
    );

    const payload = {
      providers: [
        ...(smartItem?.type
          ? [
              {
                type: smartItem.type,
                position: checkedItems.smart.position,
                status: checkedItems.smart.status ? 1 : 0,
              },
            ]
          : []),
        ...(smsItem?.type
          ? [
              {
                type: smsItem.type,
                position: checkedItems.sms.position,
                status: checkedItems.sms.status ? 1 : 0,
              },
            ]
          : []),
      ],
    };
    if (whatsappItem?.status !== checkedItems.whatsapp) {
      handleStatus(whatsappItem?.id, checkedItems?.whatsapp);
    }

    console.log("Bulk payload:", payload);

    setLoading(true);
    try {
      const res = await patch(
        `${URLS.MASTERURL}sms-gateway/bulk-update/`,
        payload,
      );
      if (res?.status === "success") {
        toast.success(res?.message || "Settings updated successfully");
        fetchData();
      }
    } catch (error) {
      console.error("Submit error:", error);
      toast.error("Failed to update settings");
    } finally {
      setLoading(false);
      setIsEdit(false);
    }
  };
  return (
    <div>
      <Topbar header={"Settings"} subHead={"SMS Gateway"} />

      {label.map((ele, i) => (
        <div
          key={ele.id}
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 10,
            margin: 10,
            alignItems: "center",
          }}
        >
          <input
            type="checkbox"
            checked={
              ele.id === "whatsapp"
                ? checkedItems.whatsapp
                : checkedItems[ele.id]?.status
            }
            onChange={(e) => handlerClick(e, ele.id)}
            style={{ width: 25, height: 25 }}
            disabled={!isEdit}
          />

          <p style={{ color: "#000", fontSize: 18 }}>{ele.value}</p>

          {ele?.isDropDown && (
            <>
              <select
                value={checkedItems[ele.id]?.position}
                onChange={
                  ele.id === "smart" ? handleSmartPriorityChange : undefined
                }
                disabled={!isEdit || ele.id === "sms"}
                style={{ borderRadius: "6px" }}
              >
                <option value={1}>1</option>
                <option value={2}>2</option>
              </select>
              <p style={{ color: "#adadad" }}>( Set the Priority )</p>
            </>
          )}
        </div>
      ))}

      {checkPermission("CAN-EDIT-SMS_GATEWAY") && (
        <>
          {!isEdit ? (
            <button
              onClick={() => setIsEdit(true)}
              className="add-btn w-10 mt-4"
            >
              Edit
            </button>
          ) : (
            <div>
              <button
                onClick={() => setIsEdit(false)}
                className="reject1-btn w-10 mt-4"
              >
                Cancel
              </button>
              &nbsp;
              <button onClick={handleSubmit} className="add-btn w-10 mt-4">
                {loading ? "Loading..." : "Submit"}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default SmsGateway;
